import React from 'react';
import {connect} from 'react-redux';
import SideMenu from '../Presentation/Navigation/SideMenu';
import PackageWrapper from '../Containers/PackageWrapper';
import Banner from '../Presentation/Banner';
import SectionTitle from '../Presentation/SectionTitle';
import SidebarPage from '../Presentation/SidebarPage';
import NewId from '../../utils/NewId';
import Loader from '../Presentation/Loader';
import MeditationsMenu from '../Presentation/Navigation/MeditationsMenu';

class MeditationsPage extends React.Component {
    render() {
        const {categories, categoriesFetched, categoriesPending} = this.props;
        const sidebar = <SideMenu><MeditationsMenu /></SideMenu>;
        let packageList;

        if (categoriesFetched) {
            const categoriesNoDescription = ['onetime'];
            packageList = categories.map(cat => <PackageWrapper key={NewId('package-wrapper')} hideDescription={categoriesNoDescription.indexOf(cat.slug) !== -1} id={cat.id} title={cat.title} packages={cat.packages} className={cat.slug} />);
        }

        return <div className="meditations-page">
            <SidebarPage sidebar={sidebar} title="Медитации">

                {/*<Banner imgSrc="/img/banner-girl.svg">*/}
                    {/*<div className="new-label">Ново</div>*/}
                    {/*<SectionTitle>Спокоен сън</SectionTitle>*/}
                    {/*<p>Създайте си перфектните условия за един истински и отморяващ сън.</p>*/}
                {/*</Banner>*/}

                <section>
                    <Loader show={categoriesPending} />
                    {packageList}
                </section>
            </SidebarPage>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        samplePackages: state.packages.samplePackages,
        categories: state.category.categories,
        categoriesFetched: state.category.getCategoriesFetched,
        categoriesPending: state.category.getCategoriesPending
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(MeditationsPage);



// WEBPACK FOOTER //
// ./src/components/Pages/Meditations.js